import { useEffect } from 'react';

// Sets <title> and the meta description for a marketing page.
export function useDocumentMeta({ title, description }) {
	useEffect(() => {
		if (title) document.title = title;
		if (!description) return undefined;
		let tag = document.querySelector('meta[name="description"]');
		if (!tag) {
			tag = document.createElement('meta');
			tag.setAttribute('name', 'description');
			document.head.appendChild(tag);
		}
		tag.setAttribute('content', description);
		return undefined;
	}, [title, description]);
}
